import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/public/Home";
import Packages from "./pages/public/Packages";
import HowItWorks from "./pages/public/HowItWorks";
import ReferralProgram from "./pages/public/ReferralProgram";
import FAQ from "./pages/public/FAQ";
import About from "./pages/public/About";
import Contact from "./pages/public/Contact";
import { Terms, Privacy, Risk, AML } from "./pages/public/Policy";

import Auth from "./pages/auth/Auth";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";

import Dashboard from "./pages/member/Dashboard";
import MyPackages from "./pages/member/MyPackages";
import Production from "./pages/member/Production";
import Deposits from "./pages/member/Deposits";
import Withdrawals from "./pages/member/Withdrawals";
import Referrals from "./pages/member/Referrals";
import ReferralTreePage from "./pages/member/ReferralTreePage";
import Transactions from "./pages/member/Transactions";
import Wallet from "./pages/member/Wallet";
import Profile from "./pages/member/Profile";
import Security from "./pages/member/Security";
import GamesHub from "./pages/member/GamesHub";
import VideoPoker from "./pages/member/VideoPoker";

import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminPackages from "./pages/admin/AdminPackages";
import AdminDeposits from "./pages/admin/AdminDeposits";
import AdminWithdrawals from "./pages/admin/AdminWithdrawals";
import AdminReferralSettings from "./pages/admin/AdminReferralSettings";
import AdminReferralTree from "./pages/admin/AdminReferralTree";
import AdminProduction from "./pages/admin/AdminProduction";
import AdminLedger from "./pages/admin/AdminLedger";
import AdminWalletSettings from "./pages/admin/AdminWalletSettings";
import AdminSiteSettings from "./pages/admin/AdminSiteSettings";
import AdminNotifications from "./pages/admin/AdminNotifications";
import AdminAccounts from "./pages/admin/AdminAccounts";
import { AdminSecurity, AdminLogs } from "./pages/admin/AdminLogs";
import AdminGameSettings from "./pages/admin/AdminGameSettings";
import { Toaster } from "./components/ui/sonner";

import "./App.css";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public (English) */}
        <Route path="/" element={<Home />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/referral-program" element={<ReferralProgram />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/risk-disclosure" element={<Risk />} />
        <Route path="/aml-policy" element={<AML />} />

        {/* Auth (English) */}
        <Route path="/login" element={<Auth />} />
        <Route path="/register" element={<Auth register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Member (English) */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/packages" element={<MyPackages />} />
        <Route path="/dashboard/production" element={<Production />} />
        <Route path="/dashboard/deposits" element={<Deposits />} />
        <Route path="/dashboard/withdrawals" element={<Withdrawals />} />
        <Route path="/dashboard/referrals" element={<Referrals />} />
        <Route path="/dashboard/referral-tree" element={<ReferralTreePage />} />
        <Route path="/dashboard/transactions" element={<Transactions />} />
        <Route path="/dashboard/wallet" element={<Wallet />} />
        <Route path="/dashboard/profile" element={<Profile />} />
        <Route path="/dashboard/security" element={<Security />} />
        <Route path="/dashboard/games" element={<GamesHub />} />
        <Route path="/dashboard/games/poker" element={<VideoPoker />} />

        {/* Admin (Turkish) */}
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/kullanicilar" element={<AdminUsers />} />
        <Route path="/admin/paketler" element={<AdminPackages />} />
        <Route path="/admin/depozitolar" element={<AdminDeposits />} />
        <Route path="/admin/cekimler" element={<AdminWithdrawals />} />
        <Route path="/admin/referans-ayarlari" element={<AdminReferralSettings />} />
        <Route path="/admin/referans-agaci" element={<AdminReferralTree />} />
        <Route path="/admin/uretimler" element={<AdminProduction />} />
        <Route path="/admin/islem-defteri" element={<AdminLedger />} />
        <Route path="/admin/cuzdan-ayarlari" element={<AdminWalletSettings />} />
        <Route path="/admin/site-ayarlari" element={<AdminSiteSettings />} />
        <Route path="/admin/bildirimler" element={<AdminNotifications />} />
        <Route path="/admin/yonetici-hesaplari" element={<AdminAccounts />} />
        <Route path="/admin/guvenlik" element={<AdminSecurity />} />
        <Route path="/admin/sistem-loglari" element={<AdminLogs />} />
        <Route path="/admin/oyun-ayarlari" element={<AdminGameSettings />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}
